export const productKx = [
    {
        id: 'kx001',

        date: '2023-05-18',
        image: '/kxx/k001.jpg',
        name: '九龙山温泉怡养酒店提质改造项目可行性研究报告',
        shortDescription: '本项目位于洛阳市栾川县，工程内容为康养住宿区域新建大厅及原有住宿区改造，商务品茗、餐厅宴会、宿舍楼室内装饰改造，户外露营、室内汤池改造，室外修复道路等。投资金额：约1324.95万元。'
    },
    {
        id: 'kx002',
        date: '2023-07-25',
        image: '/kxx/k002.jpg',
        name: '文旅集团所属企业股权变更可行性研究报告',
        shortDescription: '原洛阳旅游发展集团有限公司进行更名并作为重组整合主体，将原84家子公司压减整合为11家二级公司，20家三级公司。涉及股权变更企业共 37 家。'
    },
    {
        id: 'kx003',
        date: '2023-09-08',
        image: '/kxx/k003.png',
        name: '洛阳中心城区城市阳台建设项目投资项目效益分析报告',
        shortDescription: '本项目位于洛阳市西工区，项目主要内容为住宅、车位、商业、室外工程、酒店等的投资效益分析，投资金额:约702586万元。'
    },
    {
        id: 4,
        date: '2023-11-12',
        image: '/kxx/k004.jpg',
        name: '关于“木植街乡杨湾沙场项目”收购项目可行性研究报告',
        shortDescription: '本项目位于洛阳市嵩县木植街乡，项目内容为对收购木植街乡杨湾沙场做投资类可行研究，投资金额：约2080万元。'
    },
    {
        id: 'kx004',
        date: '2024-01-20',
        image: '/kxx/k005.jpg',
        name: '伊滨区人民医院建设项目可行性研究报告',
        shortDescription: '本项目位于洛阳市伊滨区，工程内容为新建1#综合病房楼、2#传染病防治中心、6#综合楼、液氧存放间、垃圾站及污水处理、配电间、大门、地下车库、室外广场，主要包括各单体建筑的土建、装饰、给排水、暖通、电气、消防以及室外道路、广场及停车位、室外管网等内容。投资金额：约39833.1万元。'
    },
    {
        id: 'kx005',
        date: '2024-03-05',
        image: '/kxx/k006.jpg',
        name: '洛阳市智能家居产业园污水处理厂可行性研究报告',
        shortDescription: '本项目位于洛阳市伊滨区庞村镇，工程内容为建设产业园污水处理厂，日排放量按8000m³/天，主要建设办公室、调节池、清水池、污泥池、加药、过滤罐、消毒池、设备间、软膜装置、药剂储藏室、在线检测室、污泥储存室、污泥脱水间等，并包含相关专业设备购置，投资金额2888.65万元。'
    },
    {
        id: 'kx006',
        date: '2024-04-28',
        image: '/kxx/k007.jpg',
        name: '寇店镇智能制造产业园可行性研究报告',
        shortDescription: '项目位于洛阳市伊滨区寇店镇南部，项目分两个地块，地块总用地面积约为154.95亩，包含标准化厂房、技术交流中心、研发中心、实验中心等。本项目总投资：50789.08 万元。'
    },
    {
        id: 'kx007',
        date: '2024-06-15',
        image: '/kxx/k008.jpg',
        name: '栾川县跃进大渠西干渠、汤营渠提升改造工程可行性研究报告',
        shortDescription: '本项目位于栾川县潭头镇的蛮营村和汤营村，工程内容为实施渠首提升改造、护砌渠道12公里，过水涵洞5座，人行桥75m，清淤疏浚、防洪排涝等，投资金额：约1966.08万元。'
    }
]